<div class="row font-13">
  <div class="col-5 text-center">
      2020 © <b>PCS Management Consultancy Pvt. Ltd.</b> - All rights reserved.
  </div>
  <div class="col-7" style="color: red;">
      <marquee>
          <h5>For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241
          </h5>
      </marquee>
  </div>
</div>


<!-- <div class="font-13">2023 © <b>PCS Management Consultancy Pvt. Ltd.</b> - All rights reserved.</div> -->
<!-- <a class="px-4" href="http://themeforest.net/item/adminca-responsive-bootstrap-4-3-angular-4-admin-dashboard-template/20912589" target="_blank">BUY PREMIUM</a> -->
